import { useModal } from "vue-final-modal";
import BaseConfirm from "~/components/Base/Confirm.vue";

export const useBaseConfirm = (
  title: string,
  message: any,
  isMessageComponent?: boolean,
  confirmButtonLabel?: string,
  cancelButtonLabel?: string
): Promise<boolean> => {
  // Create a promise I can resolve when the userr clsoest he vuefinalmodal

  return new Promise(async (resolve, reject) => {
    const baseConfirmController = useBaseConfirmController();

    baseConfirmController.open({
      resolver: resolve,
      reject: reject,
      title,
      message,
      isMessageComponent: isMessageComponent ?? false,
      confirmButtonLabel,
      cancelButtonLabel,
    });

    // const { open, close } = useModal({
    //   component: BaseConfirm,
    //   attrs: {
    //     title,
    //     message,
    //     confirmButtonLabel,
    //     cancelButtonLabel,
    //     isMessageComponent: isMessageComponent ?? false,
    //     onConfirm: () => {
    //       close();
    //       resolve(true);
    //     },
    //     onCancel: () => {
    //       close();
    //       console.log("onCancel");
    //       resolve(false);
    //     },
    //   },
    // });

    // open();
  });
};
